import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingMovToMp3ConverterConfig } from '@/data/landingConfig/landingMovToMp3ConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_MovToMp3Converter } from './schemaObject';

interface Props {}
const MovToMp3Converter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_MovToMp3Converter} />
			<VideoLandingTemplate
				data={landingMovToMp3ConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default MovToMp3Converter;
